import type { UserSession } from "@airange/shared/auth";
import type { EduCurrentUser, EduCurrentUserRoleKey } from "./lib/edu-api-common";
import { readEduCurrentUserApplicationRoles } from "./lib/edu-api-common";
import { getStoredUser } from "./lib/session";

const EDU_ADMIN_ROLES = new Set<EduCurrentUserRoleKey>(["edu_admin", "edu_manager", "edu_teacher"]);

type InitialState = {
  currentUser?: UserSession | null;
  eduUser?: EduCurrentUser | null;
};

function canAccessEduAdmin(currentUser?: UserSession | null, eduUser?: EduCurrentUser | null) {
  if (!currentUser) return false;
  if (!eduUser) return false;
  return readEduCurrentUserApplicationRoles(eduUser).some((role) => EDU_ADMIN_ROLES.has(role));
}

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser ?? getStoredUser();
  return {
    canAccessEduAdmin: canAccessEduAdmin(currentUser, initialState?.eduUser),
  };
}
